import { createContext, useContext, useReducer, useCallback, useEffect } from 'react'
import { PAGES } from '../lib/constants'

const FinanceContext = createContext(null)

const THEME_KEY = 'lf-theme'

const initialState = {
  page: PAGES.DASHBOARD,
  activeTab: null,
  theme: (() => {
    try { return localStorage.getItem(THEME_KEY) || 'dark' } catch { return 'dark' }
  })(),
  sidebarCollapsed: false,
  error: null,
}

function reducer(state, action) {
  switch (action.type) {
    case 'SET_PAGE':
      return { ...state, page: action.payload.page || action.payload, activeTab: action.payload.tab || null }
    case 'TOGGLE_THEME':
      return { ...state, theme: state.theme === 'dark' ? 'light' : 'dark' }
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed }
    case 'SET_ERROR':
      return { ...state, error: action.payload }
    case 'CLEAR_ERROR':
      return { ...state, error: null }
    default:
      return state
  }
}

export function FinanceProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    try { localStorage.setItem(THEME_KEY, state.theme) } catch {}
  }, [state.theme])

  const navigate = useCallback((page, tab) => dispatch({ type: 'SET_PAGE', payload: tab ? { page, tab } : page }), [])
  const toggleTheme = useCallback(() => dispatch({ type: 'TOGGLE_THEME' }), [])
  const toggleSidebar = useCallback(() => dispatch({ type: 'TOGGLE_SIDEBAR' }), [])

  return (
    <FinanceContext.Provider value={{ state, dispatch, navigate, toggleTheme, toggleSidebar }}>
      {children}
    </FinanceContext.Provider>
  )
}

export function useFinance() {
  const ctx = useContext(FinanceContext)
  if (!ctx) throw new Error('useFinance must be used within FinanceProvider')
  return ctx
}
